// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__IMEWr","textWrapper":"styles_textWrapper__bFP05","cardContainer":"styles_cardContainer__UcYC+","logo":"styles_logo__tEbRf"};